import React from "react";
import "./why-nominate.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
const WhyNominateModal = (props) => {
  return (
    <div className="why-nominate-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="nominate-modal-body">
        <p className="heading">Who can you nominate? </p>
        <p className="description">
          You can nominate one person or a number of people, we’ll check that
          your nomination adds up to 100%. You can also nominate an organisation
          – e.g. a trust or a charity, especially if you don’t have anyone
          financially dependent on you.
        </p>
        <p className="heading mt-4">Is my death benefit taxed?</p>
        <p className="description">
          The value does not form part of your estate and is usually paid free
          of tax in the UK if you pass away before 75, subject to income tax on
          payment after 75.{" "}
          {props?.isActiveMember
            ? "This includes any life assurance benefit that may be payable."
            : ""}{" "}
          Please note that unused pension balances will fall within inheritance
          tax rules from April 2027.
        </p>
        <Buttons
          name="Got it!"
          className="primary mt-3"
          handleClick={props.handleCloseButton}
        />
      </div>
    </div>
  );
};

export default WhyNominateModal;
